import React, { useState, useEffect } from "react";
import { injectIntl } from "react-intl";
import "./modalStyle.scss";
import "../../../components/PatientPreviewForm/style.scss";
import CancelIcon from '@material-ui/icons/Cancel';
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import DateFnsUtils from '@date-io/date-fns';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import Scheduler from "./Scheduler";
import { getAppointmentsUsersListRequest } from "../../../store/appointments/actions";


const ReceptionistApps = ({ intl: { messages }, show, close, patientId, selectedApp }) => {
     const lang = localStorage.getItem("lang") || "en";
     const dispatch = useDispatch();
     const [selectedAppsDate, setSelectedAppsDate] = useState(moment().format('YYYY-MM-DD'));
     const { usersList } = useSelector((state) => state.appointments);
     const [specialistList, setSpecialistList] = useState([]);
     const [selectedUserId, setSelectedUserId] = useState(0);
     /* const appTypes = [
        {id: 2, name: messages.patients.form.video_call},
        {id: 4, name: messages.patients.form.at_office},
        {id: 3, name: messages.patients.form.audio_call},
        {id: 1, name: messages.patients.form.textual_app},
    ]
     const appStatus = [
        {id: 1, name: messages.patients.form.first_app},
        {id: 2, name: messages.patients.form.inquiry_app},
        {id: 3, name: messages.patients.form.explantation_app},
    ] */
     const [appointment, setAppointment] = useState({
        patient_id: patientId,
        user_id: 0,
        start_date: '',
        type: 0,
        purpose: 1,
        time: '',
    });

     useEffect(() => {
         if (selectedAppsDate) {
            setSelectedUserId(0);
            dispatch(getAppointmentsUsersListRequest({ roleId: -2 }));
        }
    }, [dispatch, selectedAppsDate]);

    // if Selected App
    useEffect(() => {
        if (selectedApp) {
            // console.log(selectedApp);
            setSelectedAppsDate(moment(selectedApp.start_date).format('YYYY-MM-DD'));
            setSelectedUserId(selectedApp.user_id);
            setAppointment({
                ...appointment,
                id: selectedApp.id,
                user_id: selectedApp.user_id,
                start_date: moment(selectedApp.start_date).format('YYYY-MM-DD'),
                type: selectedApp.type,
                purpose: selectedApp.purpose,
                time: selectedApp.start_date.split(' ')[1],
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedApp]);

    // Users List
    useEffect(() => {
        if (usersList && usersList.length > 0) {
            let list = [];
            usersList.forEach((item) => {
                list.push({
                    id: item.id,
                    name: item.name,
                });
            });
            setSpecialistList(list);
        } else {
            setSpecialistList([]);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [usersList])

    /* useEffect(() => {
        if (parseInt(selectedUserId) > 0) {
            let appTimes = [];
            appointmentsByUsers.forEach(app => {
                if (parseInt(app.id) === parseInt(selectedUserId)) {
                    app.available_appointments?.forEach((time, index) => {
                        appTimes.push({
                            id: index,
                            value: time,
                            text: moment(time, 'HH:mm:ss').format('hh:mm A')
                        });
                    })
                }
            })
            setAvailableTimes(appTimes);
        } else {
            setAvailableTimes([]);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedUserId]) */

    return (
        <div className={`app-modal_container ${show && " show"} ${lang === 'ar' && 'rtlPosition'}`}>
            <div className="app-modal_container_content">
                    <CancelIcon onClick={close} className="app-modal_container_content_close" />
                <div className="app-modal_container_content_header">
                    <h4>{messages.appointments.specialist_appointments}</h4>
                </div>
                <div className="app-modal_container_content_body">
                    <form>
                        <div className="row">
                            <div className="col-md-8">
                                <Scheduler userId={selectedUserId} currentDate={selectedAppsDate} />
                            </div>
                            <div className="col-md-4">
                                <MuiPickersUtilsProvider utils={DateFnsUtils} local={lang === 'ar' ? 'ar-SA' : 'en-US'}>
                                    <DatePicker
                                        autoOk
                                        disableToolbar={true}
                                        orientation="landscape"
                                        variant="static"
                                        openTo="date"
                                        value={selectedAppsDate}
                                        onChange={(date) => setSelectedAppsDate(moment(date).format('YYYY-MM-DD'))}
                                    />
                                </MuiPickersUtilsProvider>
                                <div style={{ marginTop: '20px' }}>
                                    <label htmlFor="specialist" >{messages.patients.form.specialist}</label>
                                    <select name="specialist" id="specialist"
                                            style={{ width: '100%' }}
                                            value={selectedUserId}
                                            onChange={e => {
                                                document.getElementById('specialist').style.borderColor = '#eee';
                                                setSelectedUserId(e.target.value);
                                                setAppointment({ ...appointment, user_id: e.target.value })
                                                }}
                                            >
                                        <option value={0}>{messages.patients.form.specialist_placeholder}</option>
                                        {specialistList?.map(user => <option key={user.id} value={user.id}>{user.name}</option>)}
                                    </select>
                                </div>
                                {/* <div>
                                    <label htmlFor="appTypes" >{messages.patients.form.app_type}</label>
                                    <select name="appTypes" id="appTypes"
                                            style={{ width: '100%' }}
                                            value={appointment.type}
                                            onChange={e => {
                                                document.getElementById('appTypes').style.borderColor = '#eee';
                                                setAppointment({ ...appointment, type: e.target.value })
                                                }}
                                            >
                                        <option value={0}>{messages.patients.form.app_type_placeholder}</option>
                                        {appTypes?.map(type => <option key={type.id} value={type.id}>{type.name}</option>)}
                                    </select>
                                </div>
                                <div>
                                    <label htmlFor="appStatus" >{messages.patients.form.app_status}</label>
                                    <select name="appStatus" id="appStatus"
                                            style={{ width: '100%' }}
                                            value={appointment.purpose}
                                            onChange={e => {
                                                document.getElementById('appStatus').style.borderColor = '#eee';
                                                setAppointment({ ...appointment, purpose: e.target.value })
                                                }}
                                            >
                                        <option value={0}>{messages.patients.form.app_status_placeholder}</option>
                                        {appStatus?.map(status => <option key={status.id} value={status.id} 
                                                               // disabled={(status.id === 1 && appointment.purpose === 2) || (status.id === 1 && appointment.purpose === 3) || (appointment.purpose === 1 && status.id !== 1)}
                                                                >{status.name}</option>)}
                                    </select>
                                </div> */}
                            </div>
                        </div>
                       
                    </form>   
                </div>
            </div>
        </div>
    );
}
export default injectIntl(ReceptionistApps);
